import { Transformer } from "../../../../Transformer/index.js";
import Api from "../../../../Api/AddressProgramArchived/AdjustmentCommentApi";

export class AdjustmentCommentService {
  constructor() {
    this.transformer = new Transformer();
    this.Api = new Api();
  }
  async setPart(fields) {
    return await this.transformer.setFormPart(this.Api, "editAdjustmentComment", fields);
  }
  async set() {
    return await this.transformer.setForm(this.Api, "editAdjustmentComment");
  }
  async grid(args) {
    return await this.transformer.getGrid(this.Api, "getAdjustmentComments", args);
  }
  async get(id) {
    return await this.transformer.getGridPanel(this.Api, "getAdjustmentComment", null, id);
  }
  async getByAdjustmentId(adjustmentId, periodId) {
    return await this.transformer.getGrid(this.Api, "getAdjustmentCommentsByAdjustmentId", { adjustmentId, periodId });
  }
  async create(model, periodId) {
    return await this.transformer.createItem(this.Api, "createAdjustmentComment", {
      ...model,
      AdjustmentMarsPeriodId: periodId
    });
  }
  async createMany(models, periodId) {
    return await this.transformer.createItem(this.Api, "createAdjustmentComments", models.map(m => {
      return {
        ...m,
        AdjustmentMarsPeriodId: periodId
      }
    }));
  }
  async delete(model) {
    return await this.transformer.deleteItem(this.Api, "deleteAdjustmentComment", model);
  }
  async update(model) {
    return await this.transformer.editItem(this.Api, "editAdjustmentComment", model);
  }
}
